// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__1HNOl","detailsBorder":"styles_detailsBorder__2olv0"};